const base62 = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

export function getAuctionLink(car){
    let link ="/auctions/" +car.year
        .trim()
        .replaceAll(" ", "-")+"-"+car.make
        .trim()
        .replaceAll(" ", "-")+"-"+car.model
        .trim()
        .replaceAll(" ", "-")+"/" + encodeToBase62(car.uuid)
    return link

}

function encodeToBase62(uuid) {
    const uuidBuffer = Buffer.from(uuid.replace(/-/g, ""), "hex"); // Remove hyphens from UUID and create a buffer
    // Convert UUID buffer to a BigInt (128-bit number)
    let bigInt = BigInt("0x" + uuidBuffer.toString("hex"));
    let result = "";
    // Convert the BigInt to Base62
    while (bigInt > 0) {
        //@ts-ignore
        result = base62[Number(bigInt % 62n)] + result;
        //@ts-ignore
        bigInt /= 62n;
    }
    // Pad the result to ensure it's at least 8 characters long
    return result.padStart(8, "0");
}